export default function elementToObject(element, deep = false) {
    let inputs = Array.from(element.querySelectorAll('input, select, textarea'))

    return inputs
        .filter(element => {
            return !(
                !element.name
                || element.disabled
                || element.type === 'submit'
                || element.type === 'reset'
                || element.type === 'file'
                || element.type === 'image'
            )
        })
        .sort((a, b) => a.name > b.name)
        .reduce((data, element) => {
            const type = element.type
            let name = element.name
            let current = null
            let value = null

            if (element.tagName.toLowerCase() === 'select') {
                value = Array.from(element.options)
                    .filter(option => option.selected)
                    .map(option => option.value)
            } else if ((type === 'radio' || type === 'checkbox') && !element.checked) {
                // TODO: vracelo posledni hodnotu at uz byl ten input zaskrtnuty nebo ne
                // value = element.value
                return data
            } else {
                value = element.value
            }

            if (deep) {
                // doesn't handle foo[] names
                let names = name.split('[')
                if (names.length === 1) {
                    data[name] = value
                } else {
                    current = data
                    for (let i = 0; i < names.length -1; i++) {
                        name = names[i].replace(']', '')
                        if (!(name in current)) {
                            current[name] = current = {}
                        } else {
                            current = current[name]
                        }
                    }
                    current[names[names.length - 1].replace(']', '')] = value
                }
            } else {
                data[name] = value
            }

            return data
        }, {})
}
